import { DateHelper } from "_helpers/DateHelper"

export const CertificationWorkflowPackageStateConstant = {
    "Draft": 1,
    "Pending": 2,
    "Returned": 3,
    "Reviewed (Deferred)": 4,
    "Testing (Deferred)": 5,
    "Reviewed": 6,
    "Testing": 7,
    "Canceled": 8,
    "Rejected": 9,
    "Completed": 10
}

export const CertificationPackageDetails = {
    Cancel: "Cancel",
    SubmitWithWarning: "SubmitWithWarning",
    ApproveWithWarning: "ApproveWithWarning",
    Approve: "Approve",
    Reject: "Reject",
    Return: "Return",
    ApproveDeferred: "ApproveDeferred",
    RequestReview: "RequestReview"
}

export const CertificationWorkflowPackagePermissions = (userData, certificationPackage) => {
    const packageState = certificationPackage.certificationPackagePageBanner.certificationPackageState
    const vstsAccessStatus = certificationPackage.certificationPackagePageBanner.vstsAccessStatus
    const currentDate = DateHelper.GetCurrentDate()

    const isUserCertificationAdmins = userData.isSuperAdmin || (userData.isToolsAndLibAdmin && userData.isVstsWorkflowAdmin)
    const isExternalUserWithValidBid = userData.isExternalUser && userData.organization.bid == certificationPackage.certificationPackagePageBanner.bid
    const isVisaAdmins = userData.isSuperAdmin || userData.isToolsAndLibAdmin || (userData.isVisaStaff && userData.hasVisaInternalExtendedAccess);
    const isPackageStateDraft = packageState == CertificationWorkflowPackageStateConstant.Draft;
    const isPackageStatePending = packageState == CertificationWorkflowPackageStateConstant.Pending
    const isPackageStatePendingOrReturned = [CertificationWorkflowPackageStateConstant.Pending, CertificationWorkflowPackageStateConstant.Returned].includes(packageState)
    const isPackageStateDraftOrReturned = [CertificationWorkflowPackageStateConstant.Draft, CertificationWorkflowPackageStateConstant.Returned].includes(packageState)
    const IsPackageStateDeferred = [CertificationWorkflowPackageStateConstant["Reviewed (Deferred)"], CertificationWorkflowPackageStateConstant["Testing (Deferred)"]]
        .includes(packageState)

    const isDraftOrReturnedStatusEditable = isPackageStateDraftOrReturned && (isExternalUserWithValidBid || isUserCertificationAdmins)
    const isPendingStatusEditable = isPackageStatePending && isUserCertificationAdmins

    const isDocumentStateEditableGeneral = (isPackageStateDraftOrReturned || IsPackageStateDeferred) && (isUserCertificationAdmins || isExternalUserWithValidBid)
    const isDocumentStateEditableAdmin = isPackageStatePending && isUserCertificationAdmins

    return {
        IsEditable: isDraftOrReturnedStatusEditable || isPendingStatusEditable,
        IsDocumentEditable: isDocumentStateEditableGeneral || isDocumentStateEditableAdmin,
        IsCancelButtonViewable: isExternalUserWithValidBid && isPackageStateDraftOrReturned,
        IsScreenshotsUploadable: isPackageStatePendingOrReturned && isUserCertificationAdmins,
        IsScreenshotsViewable: !isPackageStateDraft && (isVisaAdmins || isExternalUserWithValidBid),
        IsReturnToClientButtonViewable: isPackageStatePending && isUserCertificationAdmins,
        IsApproveButtonViewable: isPackageStatePending && isUserCertificationAdmins,
        IsRejectButtonViewable: isPackageStatePending && isUserCertificationAdmins,
        IsPackageStateDeferred: IsPackageStateDeferred,
        IsSubmittable: isPackageStateDraftOrReturned && isExternalUserWithValidBid,
        IsCompanyContactsEditable: (isExternalUserWithValidBid && userData.isCompanyAdmin) || userData.isSuperAdmin,
        IsInternalNotesViewable: packageState != CertificationWorkflowPackageStateConstant.Draft && !userData.isExternalUser,
        IsInternalNotesEditable: isPackageStatePendingOrReturned && isUserCertificationAdmins,
        IsNotesToClientViewable: packageState != CertificationWorkflowPackageStateConstant.Draft,
        IsClientNotesEditable: isDraftOrReturnedStatusEditable || (IsPackageStateDeferred && userData.isExternalUser),
        IsUserAdmin: isUserCertificationAdmins,
        IsRequestReviewButtonViewable: IsPackageStateDeferred && isExternalUserWithValidBid,
        IsCompleted: packageState == CertificationWorkflowPackageStateConstant.Completed,
        IsApprovedToTestingDeferred: vstsAccessStatus.mergedStartDate && vstsAccessStatus.mergedEndDate
            && DateHelper.GetDate(vstsAccessStatus.mergedStartDate) <= currentDate
            && currentDate <= DateHelper.GetDate(vstsAccessStatus.mergedEndDate)
            && !vstsAccessStatus.accessDeactivated
    }
}

